<div class="form-horizontal">
  <div [formGroup]="experimentDetailsFormGroup">
    <accordion>
      <accordion-group heading="Experiment Settings" [isOpen]="true">
        <div class="form-group" [class.has-error]="control('title').invalid">
          <label class="control-label col-sm-2">Experiment Title</label>
          <span class="col-sm-10">
            <input
              formControlName="title"
              minlength="4"
              maxlength="94"
              type="text"
              class="form-control"/>
          </span>
        </div>
  
        <div class="form-group">
          <label class="control-label col-sm-2">Description</label>
          <span class="col-sm-10">
            <textarea
              formControlName="description"
              maxlength="2500"
              class="form-control">
            </textarea>
          </span>
        </div>

        <div class="form-group" [class.has-error]="control('delegate').invalid">
          <label class="control-label col-sm-2">Delegate</label>
          <span class="col-sm-10">
            <select formControlName="delegate" class="form-control">
              <option [ngValue]="null"></option>
              <option *ngFor="let option of delegates" [ngValue]="option.id">{{ option.display }}</option>
            </select>
          </span>
        </div>
        
        <div class="form-group">
          <label class="control-label col-sm-2">Regulatory Status</label>
          <span class="col-sm-7">
            <p>
              <ui-switch formControlName="ppqRequired" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
              PPQ Required
              <a tooltip="Seed or plant material subject to Plant Protection and Quarantine restrictions"
                placement="right"
                container="body">
                  <span class="glyphicon glyphicon-info-sign"></span>
              </a>
            </p>
            <p>
              <ui-switch formControlName="phytoInspectionRequired" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
              Phyto Inspection Required
              <a tooltip="Plants need to be inspected at reproductive stage, because the progeny seeds will be shipped to another state or country"
                placement="right"
                container="body">
                  <span class="glyphicon glyphicon-info-sign"></span>
              </a>
            </p>
          </span>
        </div>
  
        <div class="form-group" [class.has-error]="control('ceSite').invalid">
          <label class="control-label col-sm-2">CE Site</label>
          <span class="col-sm-10">
            <select formControlName="ceSite" class="form-control">
              <option [ngValue]="null"></option>
              <option *ngFor="let option of ceSites" [ngValue]="option.id">{{ option.display }}</option>
            </select>
          </span>
        </div>
  
        <div class="form-group" [class.has-error]="control('crop').invalid">
          <label class="control-label col-sm-2">Crop</label>
          <span class="col-sm-10">
            <select formControlName="crop" class="form-control" [attr.disabled]="disableCropSelection">
              <option [ngValue]="null"></option>
              <option *ngFor="let option of crops" [ngValue]="option.id">{{ option.display }}</option>
            </select>
          </span>
        </div>
  
        <div class="form-group" [class.has-error]="control('requestPurpose').invalid">
          <label class="control-label col-sm-2">Request Purpose</label>
          <span class="col-sm-10">
            <select formControlName="requestPurpose" class="form-control">
              <option [ngValue]="null"></option>
              <option *ngFor="let option of requestPurposes" [ngValue]="option.id">
                {{ option.display }}
              </option>
            </select>
          </span>
        </div>
      </accordion-group>
  
      <accordion-group heading="Project Settings" [isOpen]="true">
        <div class="form-group" [class.has-error]="control('pmoProgram').invalid">
          <label class="control-label col-sm-2">PMO Program</label>
          <span class="col-sm-10">
            <select formControlName="pmoProgram" class="form-control">
              <option [ngValue]="null"></option>
              <option *ngFor="let option of pmoPrograms" [ngValue]="option.id">
                {{ option.display }}
              </option>
            </select>
          </span>
        </div>
  
        <div class="form-group" [class.has-error]="control('pmoProject').invalid">
          <label class="control-label col-sm-2">PMO Project</label>
          <span class="col-sm-10">
            <select formControlName="pmoProject" class="form-control">
              <option [ngValue]="null"></option>
              <option *ngFor="let option of pmoProjects" [ngValue]="option.id">
                {{ option.display }}
              </option>
            </select>
          </span>
        </div>
  
        <div class="form-group" [class.has-error]="control('productConcept').invalid">
          <label class="control-label col-sm-2">Product Concept</label>
          <span class="col-sm-10">
            <select formControlName="productConcept" class="form-control">
              <option [ngValue]="null"></option>
              <option *ngFor="let option of productConcepts" [ngValue]="option.id">
                {{ option.display }}
              </option>
            </select>
          </span>
        </div>
      </accordion-group>
  
      <accordion-group heading="Milestones" [isOpen]="true">
        <div>
          <div class="form-group" [class.has-error]="control('plantingDate').invalid">
            <label class="control-label col-sm-2">Desired Planting Date</label>
            <app-ce-date-picker
              [formGroup]="experimentDetailsFormGroup"
              formControlName="plantingDate"
              [isDisabled]="false"
              [minDate]="earliestPlantingDate()"
              ngDefaultControl>
            </app-ce-date-picker>
            <small *ngIf="isWheatCrop" class="form-text text-muted text-right">
              Please Note: 7 day dormancy break is added to all milestone timelines.
            </small>
          </div>
          <div class="col-sm-10 col-sm-offset-2 alert alert-danger" *ngIf="!control('plantingDate').pristine && control('plantingDate').errors?.min">
            Planting date must be 12 days after today
          </div>
          <div *ngIf="showColdTreatmentInput">
            <div class="form-group" *ngIf="control('weeksOfColdTreatment').enabled"  [class.has-error]="control('weeksOfColdTreatment').invalid">
              <label class="control-label col-sm-2">Weeks of Cold Treatment              
              </label>
              <span class="col-sm-10">
                <input
                  [formGroup]="experimentDetailsFormGroup"
                  formControlName="weeksOfColdTreatment"                
                  type="number" 
                  min="0"
                  class="form-control"/>
              </span>
            </div>
            <div class="col-sm-10 col-sm-offset-2 alert alert-danger" *ngIf="!control('weeksOfColdTreatment').pristine && control('weeksOfColdTreatment').errors?.min">
              Number of weeks for Wheat Cold Treatment can not be less than zero
            </div>
          </div>
          
          <div class="form-group" *ngIf="control('seedPacketDate').enabled" [class.has-error]="control('seedPacketDate').invalid">
            <label class="control-label col-sm-2">Harvested Seed Available in Packet
              <a tooltip="The date on which the requester can expect progeny seeds from this experiment to be available in greenhouse inventory for use"
                placement="right"
                container="body">
               <span class="glyphicon glyphicon-info-sign"></span>
             </a> 
            </label>
            <app-ce-date-picker
              [formGroup]="experimentDetailsFormGroup"
              formControlName="seedPacketDate"
              [isDisabled]="!control('plantingDate')?.value"
              [minDate]="earliestSeedPacketDate"
              ngDefaultControl></app-ce-date-picker>
          </div>
          <div class="col-sm-10 col-sm-offset-2 alert alert-danger" *ngIf="!control('seedPacketDate').pristine && control('seedPacketDate').errors?.min">
            Seed packet date must at least {{averageDaysForSeedMaturity}} days ({{earliestSeedPacketDate | date:'MM/dd/yyyy'}}) after planting date
          </div>
        </div>
      </accordion-group>
    </accordion>
  </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-details/experiment-details-form/experiment-details-form.component.html